import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebarCollapsedSubject = new BehaviorSubject<boolean>(false);
  sidebarCollapsed$ = this.sidebarCollapsedSubject.asObservable();

  setSidebarCollapsed(collapsed: boolean): void {
    this.sidebarCollapsedSubject.next(collapsed);
  }

  collapseSidebarDOM(): void {
    // kwa-platform-nav (v0.1.2-beta) exposes no programmatic API to collapse it —
    // its only attributes are `hovering`, `collapsible`, and `id`.
    // The only way to trigger a collapse is to click the internal collapse button
    // inside its shadow DOM. The MutationObserver in app.component then picks up
    // the resulting class change and keeps Angular state in sync.
    const kwaSidebar = document.querySelector('kwa-platform-nav') as HTMLElement;
    const platformNav = kwaSidebar?.shadowRoot?.querySelector('.platform-nav') as HTMLElement;
    if (platformNav && !platformNav.classList.contains('collapsed')) {
      const collapseBtn = kwaSidebar.shadowRoot?.querySelector(
        '.nav-item.collapse-option'
      ) as HTMLElement;
      collapseBtn?.click();
    }
  }
}
